import React, { useEffect, useState } from 'react';
import {
  Checkbox,
  Divider,
  Grid,
  LinearProgress,
  Paper,
  Theme,
  Typography
} from '@material-ui/core';
import TermsAndConditionModal from '../../../../components/popups/modals/terms-and-conditions/TermsAndCondition.modal';
import { Button } from '../../common/button/Button';
import colors from '../../../../styles/colors';
import { makeStyles } from '@material-ui/core/styles';
import AssignmentCardList from './assignment-card/AssignmentCardList';
import FolderList from './folder-card/FolderList';
import { Add, KeyboardArrowDown } from '@material-ui/icons';
// Calendar
import { useDispatch } from 'react-redux';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AssignmentWithPenIcon from '../../common/icons/AssignmentWithPenIcon';
import { fetchApi } from '../../../../redux/actions/fetch-actions';
import { APIEndpoints, APIMethods } from '../../../../types/fetch/fetch-types';
import { AxiosError, AxiosResponse } from 'axios';
import View from '../../../../components/view/View';
import { useHistory } from 'react-router-dom';
import { teacherRoutes } from '../../../../constants/routes';
import { useAppSelector } from '../../../../redux/hooks';
import { USER_EDIT_FEATURES } from '../../../../redux/types/user/user-action-type';
import AssignmentCardAddAssignment from './assignment-card/AssignmentCardAddAssignment';
import {
  MODAL_ASSIGN_USER_GENERATED_CONTENT,
  MODAL_CREATE_ASSIGNMENT,
  MODAL_CREATE_PRE_MADE_ASSIGNMENT,
  MODAL_CREATE_TEST_PREP,
  MODAL_DEFAULT,
  MODAL_UGC_CREATE_TEST_PREP
} from '../../../../constants/modals';
import { show } from 'redux-modal/lib/actions';
import { refreshToken } from '../../../../redux/login/login-actions';
import { push } from 'react-router-redux';
import useQueryParams from '../../../../hooks/UseQueryParams';
import usePrevious from '../../../../hooks/UsePrevious';
import { DragAndDropProvider } from './context/DragAndDrop.context';
const useStyles = makeStyles((theme: Theme) => ({
  contentPadding: {
    padding: '1.5rem'
  },
  container: {
    minHeight: '80vh'
  },
  headerButtons: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  addFolder: {
    color: colors.assignment.blue,
    display: 'flex',
    justifyContent: 'flex-end',
    fontSize: '12px'
  }
}));

const MyAssignmentsView: React.FC<any> = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const userData = useAppSelector(state => state.userData);
  const planner = useAppSelector(state => state.planner);
  const query = useQueryParams();
  const { folderId } = query;
  const userClasses = useAppSelector(state => state.class.classes);
  const filteredUserClasses = userClasses.filter(
    (currentClass: any) =>
      currentClass.roster.length > 0 && !currentClass.archived
  );
  const [isTermsAccepted, setIsTermsAccepted] = useState<boolean>(
    userData?.features?.userGeneratedContent?.acceptedTerms
  );
  const previousFolderId = usePrevious(folderId);
  const [isPageLoading, setIsPageLoading] = useState<boolean>(true);
  const [isFolderLoading, setIsFolderLoading] = useState(false);
  const [assignments, setAssignments] = useState<any>([]);
  const [paths, setPaths] = useState([]);
  const [folders, setFolders] = useState<any>([]);

  const dashboardUserId =
    userData?.features?.userGeneratedContent?.dashboardUserId;
  const classCodes = filteredUserClasses.map(
    (userClass: any) => userClass.code
  );

  useEffect(() => {
    fetchPlannerAndRetrieveAssignments();
  }, []);

  /**
   * When planner gets updated re-fetch assignments
   */
  useEffect(() => {
    if (dashboardUserId && classCodes) {
      fetchAssignmentFeed(classCodes, folderId);
    }
  }, [planner]);

  /**
   * Updates when the query param for folder changes
   */
  useEffect(() => {
    if (previousFolderId !== folderId) {
      setIsPageLoading(true);
      fetchAssignmentFeed(classCodes, folderId);
    }
  }, [folderId]);

  /**
   * @description syncs user information to education database
   */
  const syncUserWithServer = () => {
    /**
     * Sync user data to education database
     */
    dispatch(
      fetchApi({
        url: 'user-generated-content/sync',
        method: APIMethods.POST
      })
    )
      .then((response: AxiosResponse) => {
        const { data } = response;
        const featureData = {
          ...userData.features.userGeneratedContent,
          dashboardUserId: data.id
        };
        dispatch({
          type: USER_EDIT_FEATURES,
          payload: {
            featureName: 'userGeneratedContent',
            featureData
          }
        });
      })
      .catch((err: AxiosError) => {
        console.log(err);
      });
  };

  /**
   * @description gets assignments
   * @param classCode
   * @param folderId
   */
  const fetchAssignmentFeed = (classCode: string[], folderId?: number) => {
    const url = folderId
      ? `v1/user-generated/feed?classCode=${classCode.join(
          ','
        )}&folderId=${folderId}`
      : `v1/user-generated/feed?classCode=${classCode.join(',')}`;
    return dispatch(
      fetchApi({
        url,
        method: APIMethods.GET,
        endpoint: APIEndpoints.EDUCATION
      })
    )
      .then((response: AxiosResponse) => {
        const { data } = response;
        const { assignments, folders, paths } = data;
        setAssignments(assignments);
        setFolders(folders);
        setPaths(paths);
        setIsPageLoading(false);
      })
      .catch((error: AxiosError) => {
        if (error.response?.status === 403) {
          dispatch(refreshToken());
        }
        if (error.response?.status === 404) {
          dispatch(push(history.location.pathname));
        }
        setIsPageLoading(false);
      });
  };

  const fetchPlannerAndRetrieveAssignments = () => {
    setIsPageLoading(true);
    syncUserWithServer();
    if (dashboardUserId) {
      fetchAssignmentFeed(classCodes, folderId);
    } else {
      setIsPageLoading(false);
    }
  };

  const classes = useStyles();

  /**
   * Terms and service
   */
  const handleTermsAndService = (isAccepted: boolean) => {
    setIsTermsAccepted(isAccepted);
    if (isAccepted) {
      dispatch(
        fetchApi({
          url: 'user-generated-content/terms',
          method: APIMethods.POST,
          data: {
            accepted: true
          }
        })
      )
        .then(() => {
          const featureData = {
            ...userData?.features?.userGeneratedContent,
            acceptedTerms: true
          };
          dispatch(refreshToken());
          dispatch({
            type: USER_EDIT_FEATURES,
            payload: {
              featureName: 'userGeneratedContent',
              featureData
            }
          });
        })
        .catch((err: AxiosError) => {
          console.log(err);
        });
    }
  };

  /**
   * Add folder
   */
  const handleAddFolder = () => {
    const isAnyInEditMode = folders.find((folder: any) => folder.isEditMode);
    if (!isAnyInEditMode) {
      return setFolders([...folders, { isEditMode: true }]);
    }
    dispatch(
      show('snackbar', {
        variant: 'error',
        message: 'Please finish creating folder first'
      })
    );
  };

  const handleFolderEdit = async (folderId: number, name: string) => {
    let response = null;
    if (!name || name.length === 0 || name.trim() === '') {
      return dispatch(
        show('snackbar', {
          variant: 'error',
          message: 'Folder name cannot be empty.'
        })
      );
    }
    try {
      response = await dispatch(
        fetchApi({
          endpoint: APIEndpoints.EDUCATION,
          url: `v1/user-generated/folder/${folderId}`,
          method: APIMethods.PATCH,
          data: {
            name
          }
        })
      );
    } catch (err) {
      const errorText =
        err.response.status === 400
          ? err.response.data.message
          : 'Error trying to update folder';
      dispatch(
        show('snackbar', {
          variant: 'error',
          message: errorText
        })
      );
    }
    if (response) {
      const { folder } = response.data;
      const newFolders = [...folders];
      for (let i = 0; i < newFolders.length; i++) {
        let newFolder = newFolders[i];
        if (newFolder.id === folderId) {
          newFolders[i] = { ...folder };
          newFolders[i].isEditMode = false;
        }
      }
      setFolders([...newFolders]);
    }
  };

  /**
   * @description moves folder to new parent item
   * @param moveItem
   */
  const handleFolderItemMove = async (moveItem: {
    parentId: number;
    id: number;
  }) => {
    let response = null;
    setIsFolderLoading(true);
    try {
      response = await dispatch(
        fetchApi({
          endpoint: APIEndpoints.EDUCATION,
          url: 'v1/user-generated/folder/move',
          method: APIMethods.PUT,
          data: {
            newParentId: moveItem.parentId,
            id: moveItem.id
          }
        })
      );
    } catch (err) {
      const errorText =
        err.response.status === 400
          ? err.response.data.message
          : 'Error trying to move item';
      dispatch(
        show('snackbar', {
          variant: 'error',
          message: errorText
        })
      );
    }
    if (response) {
      fetchAssignmentFeed(classCodes, folderId);
    }
    setIsFolderLoading(false);
  };

  const deleteFolder = async (deleteFolderId: number) => {
    let response = null;
    setIsFolderLoading(true);
    try {
      response = await dispatch(
        fetchApi({
          endpoint: APIEndpoints.EDUCATION,
          url: `v1/user-generated/folder/${deleteFolderId}`,
          method: APIMethods.DELETE
        })
      );
    } catch (err) {
      const errorText =
        err.response.status === 400
          ? err.response.data.message
          : 'Error trying to delete folder';
      dispatch(
        show('snackbar', {
          variant: 'error',
          message: errorText
        })
      );
    }
    if (response) {
      fetchAssignmentFeed(classCodes, folderId);
    }
    setIsFolderLoading(false);
  };

  const handleFolderDelete = async (deleteFolderId: number) => {
    dispatch(
      show('modal', {
        type: MODAL_DEFAULT,
        title: 'Delete folder',
        children: () => (
          <Typography>
            Are you sure you want to delete this folder? 
            All assignments and folders in this folder will be deleted.
          </Typography>
        ),
        actions: (handleHide: any) => {
          return (
            <>
              <Button
                onClick={() => {
                  deleteFolder(deleteFolderId);
                  handleHide();
                }}
                style={{width:80,height:40,margin:10}}
                textColor={'white'}
                color={colors.red}
                variant={'filled'}
              >
                Delete
              </Button>
            </>
          );
        }
      })
    );
  };

  const handleCreateFolder = async (name: string) => {
    let response = null;
    if (!name || name.length === 0 || name.trim() === '') {
      return dispatch(
        show('snackbar', {
          variant: 'error',
          message: 'Folder name cannot be empty.'
        })
      );
    }
    try {
      response = await dispatch(
        fetchApi({
          endpoint: APIEndpoints.EDUCATION,
          url: 'v1/user-generated/folder',
          method: APIMethods.POST,
          data: {
            name,
            parentId: folderId
          }
        })
      );
    } catch (err) {
      const errorText =
        err.response.status === 400
          ? err.response.data.message
          : 'Error trying to update folder';
      dispatch(
        show('snackbar', {
          variant: 'error',
          message: errorText
        })
      );
    }
    if (response) {
      const { folder } = response.data;
      const newFolders = [...folders];
      for (let i = 0; i < newFolders.length; i++) {
        let newFolder = newFolders[i];
        if (newFolder.isEditMode) {
          newFolders[i] = { ...folder };
          newFolders[i].isEditMode = false;
        }
      }
      setFolders([...newFolders]);
    }
  };

  /**
   * Test Prep
   */
  const handleAssignTestPrep = () => {
    dispatch(
      show('modal', {
        type: MODAL_UGC_CREATE_TEST_PREP,
        folderId
      })
    );
  };

  /**
   * Pre-made assignments
   */
  const handleAssignPreExistingAssignments = () => {
    dispatch(
      show('modal', { type: MODAL_CREATE_PRE_MADE_ASSIGNMENT, folderId })
    );
  };

  /**
   * Create custom assignment
   */
  const handleCreateCustomAssignment = () => {
    history.push(
      `${teacherRoutes.userGeneratedAssignmentsEditNew}?folderId=${folderId ||
        0}`
    );
  };

  const updateFolderList = (folders: any[]) => {
    setFolders(folders);
  };

  const menuItems = [
    {
      handler: handleCreateCustomAssignment,
      title: 'Custom Assignment',
      icon: AssignmentWithPenIcon
    },
    {
      handler: handleAssignPreExistingAssignments,
      title: 'Pre-made Assignment',
      icon: AssignmentIcon
    }
  ];

  const handleAssign = (
    assignment: any,
    userClasses: any,
    dashboardUserId: number,
    assignmentId: number,
    isFromEdit: boolean
  ) => {
    dispatch(
      show('modal', {
        type: MODAL_ASSIGN_USER_GENERATED_CONTENT,
        assignment,
        userClasses,
        dashboardUserId,
        assignmentId,
        isFromEdit,
        retrieveAssignments: () => fetchAssignmentFeed(classCodes, folderId)
      })
    );
  };

  /**
   * Change to report page for full view
   */
  // function navigateToReportPage() {
  //   return dispatch(
  //     push(
  //       `${teacherRoutes.classReportsAssignmentTool.replace(
  //         ':classCode',
  //         currentClass.code
  //       )}`
  //     )
  //   );
  // }

  return (
    <View>
      <Grid container spacing={3}>
        <TermsAndConditionModal
          show={!isTermsAccepted}
          onClick={handleTermsAndService}
        />
        <Grid item xs={12} md={12}>
          <Paper className={classes.container} elevation={2}>
            <Grid container>
              <Grid container className={classes.contentPadding}>
                <Grid item xs={12} md={4}>
                  <Typography variant="h5">
                    <b>Assignments</b>
                  </Typography>
                </Grid>
                <Grid item xs={12} md={8} className={classes.headerButtons}>
                  <Button
                    variant="filled"
                    textColor="white"
                    onClick={handleAssignTestPrep}
                    color={colors.assignment.turquoise}
                  >
                    Assign Test Prep
                  </Button>
                  &nbsp;
                  <Button
                    variant="filled"
                    textColor="white"
                    iconSuffix={KeyboardArrowDown}
                    menuItems={menuItems}
                    color={colors.assignment.blue}
                  >
                    Create Assignment
                  </Button>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              {isFolderLoading && (
                <Grid item xs={12}>
                  <LinearProgress />
                </Grid>
              )}
              {isPageLoading ? (
                <Grid item xs={12}>
                  <LinearProgress />
                </Grid>
              ) : (
                <Grid item xs={12} className={classes.contentPadding}>
                  <Grid container spacing={2}>
                    <Grid className={classes.addFolder} item xs={12}>
                      <Button
                        onClick={handleAddFolder}
                        icon={Add}
                        variant={'outline'}
                        color={colors.assignment.blue}
                        textColor={colors.assignment.blue}
                      >
                        Add Folder
                      </Button>
                    </Grid>
                    <DragAndDropProvider>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <FolderList
                            handleFolderItemMove={handleFolderItemMove}
                            handleFolderEdit={handleFolderEdit}
                            updateFolderList={updateFolderList}
                            handleFolderDelete={handleFolderDelete}
                            handleCreateFolder={handleCreateFolder}
                            folders={folders}
                            paths={paths}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <AssignmentCardList
                            userClasses={filteredUserClasses}
                            assignments={assignments}
                            handleAssign={handleAssign}
                          >
                            <AssignmentCardAddAssignment
                              handleCustom={handleCreateCustomAssignment}
                              handlePreMade={handleAssignPreExistingAssignments}
                            />
                          </AssignmentCardList>
                        </Grid>
                      </Grid>
                    </DragAndDropProvider>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Paper>
        </Grid>
        {/*<Grid item xs={12} md={4}>*/}
        {/*<Paper elevation={2}>*/}
        {/*  <Grid container>*/}
        {/*    <Grid item xs={12} className={classes.contentPadding}>*/}
        {/*      <Typography variant="h5">*/}
        {/*        <b>Assignments Calendar</b>*/}
        {/*      </Typography>*/}
        {/*      <Typography>{currentClass.code}</Typography>*/}
        {/*    </Grid>*/}
        {/*    <Grid item xs={12}>*/}
        {/*      <Divider />*/}
        {/*    </Grid>*/}
        {/*    <Grid item xs={12}>*/}
        {/*      <AssignmentCalendar*/}
        {/*        assignments={assignments}*/}
        {/*        userType={userData.userType}*/}
        {/*        planner={planner}*/}
        {/*      />*/}
        {/*    </Grid>*/}
        {/*    <Grid item xs={12} style={{ padding: '0rem 1.5rem 1.5rem' }}>*/}
        {/*      <Box textAlign={'right'}>*/}
        {/*        <Button*/}
        {/*          onClick={navigateToReportPage}*/}
        {/*          variant={'outline'}*/}
        {/*          style={{ padding: '.5rem 1rem' }}*/}
        {/*          textColor={colors.assignment.turquoise}*/}
        {/*          color={colors.assignment.turquoise}*/}
        {/*        >*/}
        {/*          View All Reports*/}
        {/*        </Button>*/}
        {/*      </Box>*/}
        {/*    </Grid>*/}
        {/*  </Grid>*/}
        {/*</Paper>*/}
        {/*  <Grid item xs={12}>*/}
        {/*    <Typography style={{ color: 'grey', marginTop: '1rem' }}>*/}
        {/*      <a target={'_blank'} href={links.termsAndConditions}>*/}
        {/*        * Terms and conditions*/}
        {/*      </a>*/}
        {/*    </Typography>*/}
        {/*  </Grid>*/}
        {/*</Grid>*/}
      </Grid>
    </View>
  );
};

export default MyAssignmentsView;
